/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import "./lib/i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Global } from "@emotion/react";
import { App } from "./App";
import { globalStyles } from "./styles/global";

const elem = document.getElementById("root");
if (!elem) {
  throw new Error("Root element not found");
}
const app = (
  <StrictMode>
    <Global styles={globalStyles} />
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  if (!import.meta.hot.data.root) {
    import.meta.hot.data.root = createRoot(elem);
  }
  const root = import.meta.hot.data.root;
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
